import React, {useEffect, useRef} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormCheckbox from "../../formComponents/FormCheckbox";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";

const RegionsItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);
    const controlRefCountry = useRef(null);
    const controlRefIsHidden = useRef(null);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefCountry.current.validateIsSelected("Нужно выбрать страну!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
            country_id: controlRefCountry.current.getSelectedId(),
            is_region_city: initData?.is_region_city ?? false,
            is_hidden: controlRefIsHidden.current.getChecked(),
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock
                title="Основные"
                mode={initData?.is_region_city ? "warn" : "normal"}
                subTitle={initData?.is_region_city ? "Это город-регион. Для редактирования используйте вкладку 'Города'" : undefined}
            >
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={350}
                    initValue={initData?.name ?? ""}
                    readOnly={initData?.is_region_city ?? false}
                />
                <FormLinkedItemSelect
                    controlRef={controlRefCountry}
                    label="Страна"
                    widthLimit={450}
                    initSelectedId={initData?.country_id}
                    initRefList={initData?.refs?.countries}
                    apiName2="countries"
                    showIds={true}
                    readOnly={initData?.is_region_city ?? false}
                />
            </FormBlock>
            <FormBlock title="Специальные">
                <FormCheckbox
                    controlRef={controlRefIsHidden}
                    label="Скрывать регион"
                    initValue={initData?.is_hidden ?? false}
                />
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

export default RegionsItemForm;